import React, { useState, useEffect } from 'react'
import { Header, Comment, Label, Icon, Rating, Grid, Placeholder } from 'semantic-ui-react'
import { useTranslation } from "react-i18next";
import ReactPaginate from 'react-paginate';
import ShowMoreText from "react-show-more-text";

import "./AccommodationReviews.css"

const items = [
    {
        name: "فرناز عبداللهی",
        date: "سه روز پیش",
        score: "۲",
        cmt: "بسیار عالی بود از همه نظر به همه توصیه میکنم."
    },
    {
        name: "فرناز عبداللهی",
        date: "سه روز پیش",
        score: "۲",
        cmt: " واحد تمیزی بود فقط اگر اسکاچی که سرویس ها را تمیز می کنند داخل سرویس نباشه زیباتره . آب چکان ظرفشویی طوری بود که آب روی کابینت و از آنجا کف آشپزخانه می ریخت ولذا پیشنهاد می کنم یک قالیچه یا پادری کوچک زیر کابینت ثابت بشه!"
    },

    {
        name: "فرناز عبداللهی",
        date: "سه روز پیش",
        score: "۲",
        cmt: " واحد تمیزی بود فقط اگر اسکاچی که سرویس ها را تمیز می کنند داخل سرویس نباشه زیباتره . آب چکان ظرفشویی طوری بود که آب روی!"
    },
    {
        name: "فرناز عبداللهی",
        date: "سه روز پیش",
        score: "۲",
        cmt: "بسیار عالی بود از همه نظر به همه توصیه میکنم."
    },
]
const AccommodationReviews = () => {
    const { t } = useTranslation();
    const itemsPerPage = 2
    const [currentItems, setCurrentItems] = useState(null);
    const [pageCount, setPageCount] = useState(0);
    const [offset, setOffset] = useState(0);

    useEffect(() => {
        // Fetch items from another resources.
        const endOffset = offset + itemsPerPage;
        setCurrentItems(items.slice(offset, endOffset));
        setPageCount(Math.ceil(items.length / itemsPerPage));
    }, [offset, itemsPerPage]);

    const handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % items.length;
        console.log(
            `User requested page number ${event.selected}, which is offset ${newOffset}`
        );
        setOffset(newOffset);
    };


    return (<div className="AccommodationReviews">
        <div className="d-flex flex-row align-items-center">
            <Label basic className="border-none d-flex flex-row align-items-center ">
                <Icon className="m-0 m-4px-b" name='star' color="red" />
                <Header className="m-0" as='h3'> 4.95</Header>
            </Label>
            .
            <Label basic className="border-none d-flex flex-row align-items-center ">
                <Header as='h3' className="m-0 p-4px-r p-4px-l">20</Header>
                <Header as='h3' className="m-0"> {t("property:Reviews")}</Header>
            </Label>
        </div>

        <Grid columns="3" className="p-1 m-1-t" divided stackable>
            <Grid.Row>
                <Grid.Column>
                    <Grid.Row className="d-flex justify-content-between">
                        {t("property:Cleanliness")}
                        <Rating defaultRating={3} maxRating={5} disabled />
                    </Grid.Row>
                </Grid.Column>
                <Grid.Column>
                    <Grid.Row className="d-flex justify-content-between">
                        {t("property:Accessibility")}
                        <Rating defaultRating={3} maxRating={5} disabled />
                    </Grid.Row>
                </Grid.Column>
                <Grid.Column>
                    <Grid.Row className="d-flex justify-content-between">
                        {t("property:ComplianceWithAdsOnTheSite")}
                        <Rating defaultRating={3} maxRating={5} disabled />
                    </Grid.Row>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column>
                    <Grid.Row className="d-flex justify-content-between">
                        {t("property:ValueToPriceRatio")}
                        <Rating defaultRating={3} maxRating={5} disabled />
                    </Grid.Row>
                </Grid.Column>
                <Grid.Column>
                    <Grid.Row className="d-flex justify-content-between">
                        {t("property:HostingQuality")}
                        <Rating defaultRating={3} maxRating={5} disabled />
                    </Grid.Row>
                </Grid.Column>
                <Grid.Column>
                    <Grid.Row className="d-flex justify-content-between">
                        {t("property:Neighborhood")}
                        <Rating defaultRating={3} maxRating={5} disabled />
                    </Grid.Row>
                </Grid.Column>
            </Grid.Row>
        </Grid>

        <Grid columns={2} stackable>

            {
                currentItems ? currentItems.map((item, index) => {
                    return <Grid.Column>
                        <Comment.Group>
                            <Comment>
                                <Comment.Avatar as='a' src='https://react.semantic-ui.com/images/avatar/small/stevie.jpg' />
                                <Comment.Content>
                                    <Comment.Author>{item.name}</Comment.Author>
                                    <Comment.Metadata>
                                        <div>{item.date}</div>
                                        <div>
                                            <Icon name='star' />{item.score} امتیاز
                                        </div>
                                    </Comment.Metadata>

                                </Comment.Content>
                                <Comment.Text className="m-1">
                                    <ShowMoreText
                                        lines={3}
                                        more={t("property:More")}
                                        less={t("property:Less")}
                                        className="content-css"
                                        anchorClass="my-anchor-css-class"
                                        expanded={false}
                                        truncatedEndingComponent={""}
                                    >
                                        {item.cmt}
                                    </ShowMoreText>
                                </Comment.Text>
                            </Comment>
                        </Comment.Group>
                    </Grid.Column>
                }) : <Placeholder fluid>
                    <Placeholder.Header image>
                        <Placeholder.Line />
                        <Placeholder.Line />
                    </Placeholder.Header>
                    <Placeholder.Paragraph>
                        <Placeholder.Line />
                        <Placeholder.Line />
                        <Placeholder.Line />
                    </Placeholder.Paragraph>
                </Placeholder>
            }

        </Grid>
        <ReactPaginate
            breakLabel="..."
            nextLabel={t("property:Next")}
            onPageChange={handlePageClick}
            pageRangeDisplayed={5}
            pageCount={pageCount}
            previousLabel={t("property:Previous")}
            renderOnZeroPageCount={null}
            className="d-flex pagination"
            activeClassName="active"
        />

    </div>
    )
}
export default AccommodationReviews